/** Created by azhou on 2018/9/12.*/
<template>
  <div class="d-flex flex-wrap">
    <div class="d-center-start w-50 mb-3"><left-text leftText="总积分"/>{{StoreBasicInfo.score}}</div>
    <div class="d-center-start w-50 mb-3"><left-text leftText="可用余额"/>{{StoreBasicInfo.money/100 | formatMoney}} 元</div>
    <div class="d-center-start w-50 mb-3"><left-text leftText="联系人"/>{{StoreBasicInfo.contact}}</div>
    <div class="d-center-start w-50 mb-3"><left-text leftText="联系电话"/>{{StoreBasicInfo.mob}}</div>
    <div class="d-center-start w-50 mb-3"><left-text leftText="办公电话"/>{{StoreBasicInfo.tel}}</div>
    <div class="d-center-start w-50 mb-3"><left-text leftText="总机电话"/>{{StoreBasicInfo.travel_tel}}</div>
    <div class="d-center-start w-50 mb-3"><left-text leftText="银行卡"/>
      已绑定 <span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','bankcard')">{{StoreBasicInfo.bankcard}}</span>张银行卡
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    data() {
      return {
        showIndex:0,
        bankcardLists:[]
      }
    },
    computed: {
      ...mapState(['StoreBasicInfo']),
    },
    methods: {
      /*获取银行卡列表*/
      getBankcardInvoice(){
        let url = this.BASE_URL + '/pc/Admin/getBankcardList';
        $.post(url,{
          needToken: this.userLoginMessage.token,
          needType: 1,
          store_id: this.queryInfo.id,
          store_type:this.queryInfo.type,
          page:1,
          num:20
        },res=>{
          if(res.code==='00000'||res.code==='99999') {
            this.showIndex = 1;
            let resArr = res.info?res.info:[];
            this.bankcardLists = resArr;
          }
          else alert(res.msg);
        },'JSON')
      },
    }
  }
</script>
